import React from "react";
import { NavLink } from "react-router-dom";

export default function SideBarLink({ href, name, icon,handleClosemenu }) {
  //  const isNew = href === "/my-document" || href === "/early-warnings";
    const isNew =  href === "/early-warnings";
  return (
    <>
      <li>
        <NavLink
          to={href}
          className={({ isActive, isPending }) =>
            isPending ? "" : isActive ? "active" : ""
          }
          onClick={() => {
            handleClosemenu();
          }}
        >
          <span>{icon}</span>
          {name}
           {isNew && <span className="sidebar-badge-new">New</span>}
        </NavLink>
      </li>
    </>
  );
}
